import { Modal } from "antd";

export async function PostUseCandadoJavamon(idAct: string, idProb: string, userId: string, idJavamon: string) {
    const url = `${process.env.REACT_APP_API_URL}:8061/jutge/activitats/${idAct}/problemes/${idProb}/unlock`;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id_usuari: userId, id_javamon: idJavamon })
        });
        if (response.status !== 200) {
            Modal.error({
                title: 'Error',
                content: 'No se ha podido utilizar el Javamon Candado. Verifica que no hayas usado ya uno en esta actividad.',
            });
            return false;
        }

        return true;
    } catch (e) {
        console.error("PostUseCandadoJavamon Error:", e);
        throw e;
    }
}
